import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueWow from 'vue-wow'

import axios from "./axios.js"
Vue.prototype.$http = axios

// mount with global
Vue.use(VueWow)

import VueSplide from '@splidejs/vue-splide';
Vue.use( VueSplide );

// vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// Fragment ( root-less components )
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

// Vuex (Store)
import store from './store/store'

import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css'

// Vue.prototype.base_url = 'http://localhost/thrubits/'
Vue.prototype.base_url = '//thrubits.com/'
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
